// src/components/Partners.tsx
import React from "react";
import Container from "./ui/Container";
import licLogo from "../assets/lic-logo.png";
import starHealthLogo from "../assets/star-health-logo.png";
import hfclLogo from "../assets/lic-hfcl-logo.png";
import thawaLogo from "../assets/thawa-logo.jpg"
import thawaHousingLogo from "../assets/thawa-housing.png"

const partners = [
    { name: "LIC", logo: licLogo, url: "https://licindia.in" },
    { name: "LIC HFCL", logo: hfclLogo, url: "https://lichousing.com" },
    { name: "Star Health", logo: starHealthLogo, url: "https://starhealth.in" },
    { name: "Thawa FSPL", logo: thawaLogo, url: "https://thawafspl.com/" },
    { name: "Thawa Housing", logo: thawaHousingLogo, url: "https://thawafspl.com/" },
];

export default function Partners() {
    return (
        <section className="bg-gray-50 py-16">
            <Container>
                <h2 className="text-3xl font-bold text-center mb-10">Our Partners</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 items-center justify-items-center">
                    {partners.map((partner, idx) => (
                        <a
                            key={idx}
                            href={partner.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-white border rounded-xl shadow-sm p-4 flex items-center justify-center hover:shadow-md transition w-32 h-20 cursor-pointer"
                        >
                            <img
                                src={partner.logo}
                                alt={partner.name}
                                className="max-h-12 object-contain"
                            />
                        </a>
                    ))}
                </div>
            </Container>
        </section>
    );
}
